import { ROLES } from "../../modules/accounts/accountConstants";

export const relationTypes = [
  { id: ROLES.OWNER, name: "ist Eigentümer" },
  { id: ROLES.TENANT, name: "ist Mieter" },
  { id: ROLES.STAFF, name: "ist Mitarbeiter" },
  { id: ROLES.CONTRACTOR, name: "ist Dienstleister" },
  { id: ROLES.COUNSELOR, name: "ist Beirat" },
  { id: ROLES.TICKET_MANAGER, name: "ist Ticketmanager" },
];
